module.exports = __webpack_public_path__ + "img/one_1.cc53ffd1.png";